import React, { useState } from 'react';
import './DqLLMTable.css'; // Import the CSS file for styling
import NestedDqLLMTable from './NestedDqLLMTable';

const DqLLMTable = ({ item }) => {
  const [rowSelected, setRowSelected] = useState(-1);

  const { xAxis = { data: [] }, series = [] } = item || {};

  // Function to calculate the width based on the value
  const getWidthPercentage = (value) => {
    return `${value}%`;
  };

  // Function to determine the background style based on the value
  const getBackgroundStyle = (value) => {
    return {
      background:
        value === '0.00'
          ? 'linear-gradient(to right, #fadbd8, #ec7063)'
          : value === '100.00'
          ? 'linear-gradient(to right, #d4edda, #66BB6A)'
          : 'linear-gradient(to right, #ffffe0, #ffd54f)',
      width: value === '0.00' || value === '100.00' ? getWidthPercentage(100) : getWidthPercentage(parseFloat(value)),
      height: '100%',
      display: 'inline-block',
    };
  };

  return (
    <div className="dq-llm-table-container">
      {rowSelected > -1 ? (
        <NestedDqLLMTable item={item} rowSelected={rowSelected} setRowSelected={setRowSelected} />
      ) : (
        <table className="dq-llm-table">
          <thead className="dq-llm-thead">
            <tr>
              <th className="dq-llm-th">Column Name</th>
              {series.map((s, index) => (
                <th key={index} className="dq-llm-th">
                  {s.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="dq-llm-tbody">
            {xAxis.data.map((rowName, rowIndex) => (
              <tr key={rowIndex} className="dq-llm-tr">
                <td className="dq-llm-td">
                  <button className="dq-llm-td-btn" onClick={() => setRowSelected(rowIndex)}>
                    {rowName}
                  </button>
                </td>
                {series.map((s, colIndex) => (
                  <td key={colIndex} className="dq-llm-td" style={{ position: 'relative', padding: 0 }}>
                    <div className="dq-llm-background" style={getBackgroundStyle(s.data[rowIndex])} />
                    <div className="dq-llm-text">{s.data[rowIndex] === 0 ? 'NA' : `${s.data[rowIndex]}%`}</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DqLLMTable;
